import React from "react"
import ScrollPosition from "../../hook/ScrollPosition";

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const F2floor = () => {
   const scrollPosition = ScrollPosition()
   return (
      <div className='Floor flexCenter'>
         <img src={require("../../img/shop/4f.png")} alt="" />
         <div className={`${scrollPosition >= 550 ? 'originPosition' : ''}`}>
            <h2>site.A     BAR POSTSCRIPT</h2>
            <Swiper className='ShopSlide-cover' style={{
                "--swiper-pagination-color": "lavender",
                "--swiper-navigation-color": "lavender",
            }}
              // install Swiper modules
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              slidesPerView={1} navigation loop = {true}
              pagination={{ clickable: true }}
              scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/postscript-01.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/postscript-02.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/postscript-03.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
              <SwiperSlide className='ShopSlide'><img src={require("../../img/shop/postscript-04.jpg")} alt="슬라이드 이미지1" /> </SwiperSlide>
            </Swiper>
            <img src={require("../../img/logo/logo_postscript.png")} alt='' style={{width:'150px'}} />
            <p>편지를 쓰다가 미처 적지 못한 말. <br />
            꼭 덧붙여야 하는 소중한 말이 있다면 편지 끝머리에 그 말을 적어두곤 합니다.</p>
            <p className="mb60">바 피에스/포스트스크립트 에서는 사람과 사람 사이, 그 관계를 유지하기 위한 필요한 말들 외에, 못 다한 이야기를 나눌 수 있는 편안하고 퀄리티 있는 서비스를 받을 수 있는 바 입니다.</p>

            <span>Directions: A동 4층</span>
            <span>Opening hours: 11:00AM ~ 20:00PM (연중무휴)</span>
            <span>Night: 18:00PM ~ 00:00AM (Last Order : Food 22:30 / Beverage 23:30)</span>
            <span className="mb20">*유선 문의는 영업시간 1시간 전부터 이용 가능 합니다.</span>
            <a className="link-arrow" href="noscrupt:">MENU</a>
            <a className="link-arrow" href="noscrupt:">RESERVATION</a>
            <a className="link-arrow" href="noscrupt:">INSTAGRAM</a>
         </div>
      </div>
   )
}

export default F2floor
